export default __webpack_public_path__ + "static/media/15.82e104d4.jpg";